import type { GetOrders200OrdersItemItemType } from './getOrders200OrdersItemItemType';
import type { GetOrders200OrdersItemOrderType } from './getOrders200OrdersItemOrderType';
import type { GetOrders200OrdersItemStatus } from './getOrders200OrdersItemStatus';

export type GetOrders200OrdersItem = {
  /** 주문 금액 */
  amount: number;
  /** 빌링키 */
  billingKey?: string;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 이름 */
  buyerName?: string;
  /** 생성일시 */
  createdAt: string;
  /** 주문 ID */
  id: string;
  /** 상품 타입 */
  itemType?: GetOrders200OrdersItemItemType;
  /** 주문 타입 */
  orderType?: GetOrders200OrdersItemOrderType;
  /** 결제일시 */
  paymentDate?: string;
  /** 결제 방법 */
  paymentMethod?: string;
  /** 상품 코드 */
  productCode?: string;
  /** 상품명 */
  productName?: string;
  /** 플랜 코드 */
  productPlanCode?: string;
  /** 주문 상태 */
  status: GetOrders200OrdersItemStatus;
  /** 거래 ID */
  tid?: string;
  /** 수정일시 */
  updatedAt?: string;
  /** 사용자 ID */
  userId?: string;
};
